/// <reference path="../_all.ts" />

module misc {

  jsonDataDirective.$inject = [];
  export function jsonDataDirective(): ng.IDirective {


    return {
      restrict: 'A',
      scope: {  
        data: '=?',  
        onLoad: '&',
      },
      link: function (scope: any, element: ng.IAugmentedJQuery, attr: ng.IAttributes, ctrl) {   
        scope.data = JSON.parse(element[0].innerHTML); 
        if(scope.onLoad){
          scope.onLoad({data : scope.data});
        } 
      }
    }
  }

}
